module.exports = __webpack_public_path__ + "static/media/algorand-logo.25e6b9cd.svg";